module.exports = __webpack_public_path__ + "img/cafeteria.88da873b.png";